import { topics } from '@/mocks/siteData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 border-primary-200 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-700 border-accent-200 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 border-secondary-200 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">全网影视吃瓜话题实时追踪，点击查看详情</p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group relative px-4 py-3 md:px-5 md:py-3.5 rounded-xl border transition-all cursor-pointer ${colorMap[topic.color] || colorMap.primary}`}
            >
              <div className="flex items-center gap-2 mb-1">
                <span className="font-heading font-semibold text-sm md:text-base whitespace-nowrap">#{topic.tag}</span>
                <span className="text-xs opacity-70 whitespace-nowrap">{topic.heat}</span>
              </div>
              <p className="text-xs opacity-80 max-w-[220px] truncate">{topic.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}